<template>
  <div>
    <list
      row-key="DocId"
      ref="list"
      unit="付款单"
      light-row
      :page="page"
      @row-select="x=>$emit('change', x)"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      show-summary  
      :summary-method="getSummaries"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单位名称">
          <el-input v-model="params.TradeUnitName" placeholder="请输入单位名称" clearable />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input v-model="params.DocNo" placeholder="请输入单据编号" clearable />
        </el-form-item>
        <el-form-item label="业务类型">
          <el-select v-model="params.BusinessType" placeholder="请选择业务类型" clearable>
            <el-option label="应付款" :value="0"></el-option>
            <el-option label="预付款" :value="1"></el-option>
            <el-option label="直接付款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <range-picker 
          :date="[params.DocDateStart, params.DocDateEnd]"  @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}" />
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="params.Status" placeholder="请选择单据状态" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销状态">
          <el-select v-model="params.WriteoffStatus" placeholder="请选择核销状态" clearable>
            <el-option label="未核销" :value="0"></el-option>
            <el-option label="部分核销" :value="1"></el-option>
            <el-option label="已核销" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="160px" show-overflow-tooltip />
        <el-table-column prop="DocDate" label="单据日期" min-width="120px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="往来单位" min-width="120px" />
        <el-table-column prop="PayAmount" label="付款金额" />
        <!-- <el-table-column prop="WriteoffAmount" label="核销金额" /> -->
        <el-table-column label="是否生成过凭证" align="center" width="110">
          <template slot-scope="{row}">
            {{row.PushId?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="单据状态" width="100px" align="center">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-if="row.Status==1">未生效</span>
            <span v-if="row.Status==2">已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="核销状态" align="center" width="100">
          <template slot-scope="{row}">
            <span v-if="row.WriteoffStatus==0">未核销</span>
            <span v-if="row.WriteoffStatus==1">部分核销</span>
            <span v-if="row.WriteoffStatus==2">已核销</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/rp/pay").default,
      params: {
        TradeUnitName: "",
        DocNo: "",
        EmpName: "",
        BusinessType: null,
        Status: null,
        WriteoffStatus: null,
        DocDateStart:this.$commonJs.getDayOffset(-30),
        DocDateEnd:this.$commonJs.getDayOffset(0)
      },
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 4 ) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2));
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.$emit("reload");
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>